module.exports = __webpack_public_path__ + "img/Excel.663c9e05.png";